var map = {
	"./Apfel.png": 3926,
	"./Erdbeere.png": 9042,
	"./Hafer.png": 3064,
	"./Kartoffeln.png": 7909,
	"./Möhren.png": 5676,
	"./RoteBeete.png": 8322,
	"./Sellerie.png": 3015,
	"./Sommerweizen.png": 7932,
	"./Spargel.png": 908,
	"./Winterdurum.png": 2007,
	"./Wintergerste.png": 8589,
	"./Winterraps.png": 6996,
	"./Winterroggen.png": 6463,
	"./Wintertriticale.png": 5679,
	"./Winterweizen.png": 6528,
	"./Zuckerrüben.png": 3522,
	"./Zwiebeln.png": 1874,
	"./default.png": 1526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1626;